import type {
  UploaderChunkState,
  UploaderState,
} from '@iconik-io/uploader/src/state';

const NON_PROGRESS_KEYS = [
  'id',
  'fileInfo',
  'options',
  'target',
  'uploadKind',
  'status',
  'meta',
] as const satisfies readonly Exclude<keyof UploaderState, 'chunks'>[];

const isChunkProgressOnly = (
  saved: UploaderChunkState<unknown>,
  next: UploaderChunkState<unknown>,
): boolean =>
  saved.index === next.index &&
  saved.status === next.status &&
  saved.start === next.start &&
  saved.size === next.size &&
  saved.meta === next.meta;

/**
 * Whether the only thing that changed since the saved state is how many bytes
 * the chunks have uploaded.
 */
export const isProgressOnlyUpdate = (
  saved: UploaderState,
  next: UploaderState,
): boolean => {
  if (NON_PROGRESS_KEYS.some((key) => saved[key] !== next[key])) {
    return false;
  }
  const savedChunks = saved.chunks;
  const nextChunks = next.chunks;
  if (!savedChunks || !nextChunks) {
    return savedChunks === nextChunks;
  }
  return (
    savedChunks.length === nextChunks.length &&
    nextChunks.every((chunk, index) =>
      isChunkProgressOnly(savedChunks[index], chunk),
    )
  );
};
